import type { ReactNode } from 'react';

export const symbol_bolt_boost: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="M540.5-130.05q-2.5-4.06-1.5-9.95l39-269H397q-18.62 0-26.81-16.5Q362-442 373-457l273-372q4-5 8-6t9 1q5 2 7.5 6.05 2.5 4.06 1.5 9.95l-38 266h182q18.62 0 26.81 16.5Q851-519 840-504L566-129q-4 5-8.5 6t-9.5-1q-5-2-7.5-6.05ZM150-244q-12.75 0-21.37-8.68-8.63-8.67-8.63-21.5 0-12.82 8.63-21.32 8.62-8.5 21.37-8.5h270q15 0 22.5 9.32t7.5 20.5q0 11.18-7.5 20.68T420-244H150Zm-40-206q-12.75 0-21.37-8.68-8.63-8.67-8.63-21.5 0-12.82 8.63-21.32Q97.25-510 110-510h113q15 0 22.5 9.32t7.5 20.5q0 11.18-7.5 20.68T223-450H110Zm80-207q-12.75 0-21.37-8.68-8.63-8.67-8.63-21.5 0-12.82 8.63-21.32 8.62-8.5 21.37-8.5h182q15 0 22.5 9.32t7.5 20.5q0 11.18-7.75 20.68T371-657H190Z"
		/>
	</svg>
);
